
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accelerate/2022",
      function () {
        return require("private-next-pages/accelerate/2022/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accelerate/2022"])
      });
    }
  